<form class="new-filters" (ngSubmit)="search()" appFilters>
  <div class="new-filter-row guest-invite-filter-row">
    <div class="new-form-control-sm guest-invite-field guest-invite-field--title">
      <label for="guestInviteTitleNumber">Nº título</label>
      <input
        id="guestInviteTitleNumber"
        type="text"
        class="new-input guest-invite-input"
        [(ngModel)]="titleNumber"
        name="guestInviteTitleNumber"
        placeholder="Número..."
      />
    </div>

    <div class="new-form-control-sm guest-invite-field guest-invite-field--year">
      <label for="guestInviteYear">Ano</label>
      <p-dropdown
        inputId="guestInviteYear"
        styleClass="guest-invite-dropdown guest-invite-dropdown--compact"
        [(ngModel)]="filterYear"
        [options]="yearOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        placeholder="Ano"
        name="guestInviteYear"
        dropdownIcon="pi pi-chevron-down"
        [autoDisplayFirst]="false"
      >
      </p-dropdown>
    </div>

    <div class="new-form-control-sm guest-invite-field guest-invite-field--month">
      <label for="guestInviteMonth">Mês (resultado)</label>
      <p-dropdown
        inputId="guestInviteMonth"
        styleClass="guest-invite-dropdown guest-invite-dropdown--compact"
        [(ngModel)]="filterMonth"
        [options]="monthOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        name="guestInviteMonth"
        dropdownIcon="pi pi-chevron-down"
        [autoDisplayFirst]="false"
      >
      </p-dropdown>
    </div>

    <div class="guest-invite-count guest-invite-count--inline" *ngIf="inviteRows.length > 0">
      <span *ngIf="appliedMonth === 0">{{ inviteRows.length }} reg.</span>
      <span *ngIf="appliedMonth > 0">{{ displayedRows.length }}/{{ inviteRows.length }} reg.</span>
    </div>

    <div class="new-form-button guest-invite-filter-submit">
      <button class="new-easymarine primary" type="submit">
        Buscar
        &nbsp;
        <i class="pi pi-search"></i>
      </button>
    </div>
  </div>
</form>

<div class="guest-invite-summary" *ngIf="resultLoaded">
  <div class="guest-invite-summary__card guest-invite-summary__card--free">
    <div class="guest-invite-summary__label">TOTAL GRÁTIS (ANO)</div>
    <div class="guest-invite-summary__values">
      <span class="guest-invite-summary__main">{{ freeInvitesYearCount }}</span>
      <span class="guest-invite-summary__suffix">
        /{{
          invitesAfterRecharge !== null && invitesAfterRecharge !== undefined
            ? invitesAfterRecharge
            : "—"
        }}
      </span>
    </div>
  </div>
  <div class="guest-invite-summary__card guest-invite-summary__card--paid">
    <div class="guest-invite-summary__label">
      TOTAL PAGOS<span *ngIf="appliedMonth > 0">&nbsp;(MÊS)</span>
    </div>
    <div class="guest-invite-summary__values">
      <span class="guest-invite-summary__main">{{ paidInvitesCount }}</span>
      <span class="guest-invite-summary__suffix"> un.</span>
    </div>
  </div>
  <div class="guest-invite-summary__card guest-invite-summary__card--extra"
       pTooltip="Convites liberados pela marina para dias específicos. Não impactam o saldo anual."
       tooltipPosition="bottom">
    <div class="guest-invite-summary__label">EXTRAS (ANO)</div>
    <div class="guest-invite-summary__values">
      <span class="guest-invite-summary__main">{{ extrasConsumedYearCount }}</span>
      <span class="guest-invite-summary__suffix">/{{ extrasGrantedYearCount }} liberados</span>
    </div>
  </div>
  <div class="guest-invite-summary__card guest-invite-summary__card--recharge">
    <div class="guest-invite-summary__label">ÚLTIMA RECARGA</div>
    <div class="guest-invite-summary__values guest-invite-summary__values--recharge">
      <span *ngIf="lastRecharge; else noLastRecharge" class="guest-invite-summary__date">
        {{ lastRecharge | date : "dd/MM/yyyy HH:mm" }}
      </span>
      <ng-template #noLastRecharge>
        <span class="guest-invite-summary__date guest-invite-summary__date--empty">—</span>
      </ng-template>
    </div>
  </div>
</div>

<div
  class="guest-invite-liberar-bar"
  *ngIf="resultLoaded && securitiesPropertyId != null"
>
  <button
    type="button"
    class="new-easymarine primary"
    (click)="openLiberarCompraModal()"
  >
    Liberar Convites Extras
  </button>
  <button
    type="button"
    class="new-easymarine primary"
    (click)="openInviteHistoricModal()"
  >
    Histórico Convites
  </button>
  <button
    type="button"
    class="new-easymarine primary"
    (click)="openLiberarConviteGratisModal()"
  >
    Adicionar Convites Grátis
  </button>
  <button
    type="button"
    class="new-easymarine danger"
    (click)="openSuspenderRegrasModal()"
    pTooltip="Para o dia escolhido, ignora cap diário, sub-limite de pagos, cap anual e a trava de emissão paga."
    tooltipPosition="bottom"
  >
    Suspender Regras de Convite
  </button>
</div>

<div class="guest-invite-extras-wrap" *ngIf="resultLoaded && extraReleases.length > 0">
  <h4 class="guest-invite-extras-title">Liberações extras por dia</h4>
  <p-table
    [value]="extraReleases"
    styleClass="easy-table guest-invite-extras-table"
    [tableStyle]="{ 'min-width': '700px' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">Data</th>
        <th class="text-center">Tipo</th>
        <th class="text-center">Liberados</th>
        <th class="text-center">Usados</th>
        <th class="text-center">Autorizado em</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ação</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [class.guest-invite-extras-row--canceled]="row.canceledAt">
        <td class="no-wrap text-center">{{ row.releaseDate | date : "dd/MM/yyyy" }}</td>
        <td class="text-center">
          <span [class]="row.isPaid ? 'origin-pill origin-pill--extra-paid' : 'origin-pill origin-pill--extra-free'">
            {{ row.isPaid ? "Pago" : "Grátis" }}
          </span>
        </td>
        <td class="text-center">{{ row.quantity }}</td>
        <td class="text-center">{{ row.consumed || 0 }}</td>
        <td class="no-wrap text-center">{{ row.authorizedAt | date : "dd/MM/yyyy HH:mm" }}</td>
        <td class="text-center">
          <span *ngIf="row.canceledAt" class="status-pill status-pill--blocked">Cancelada</span>
          <span *ngIf="!row.canceledAt && (row.consumed || 0) >= row.quantity" class="status-pill status-pill--allowed">Concluída</span>
          <span *ngIf="!row.canceledAt && (row.consumed || 0) < row.quantity" class="status-pill status-pill--waiting">Disponível</span>
        </td>
        <td class="text-center">
          <button
            *ngIf="!row.canceledAt && (row.consumed || 0) === 0"
            type="button"
            class="easymarine danger"
            (click)="cancelExtraRelease(row)"
            pTooltip="Cancelar esta liberação extra"
            tooltipPosition="left"
          >
            <i class="pi pi-times"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="guest-invite-extras-wrap" *ngIf="resultLoaded && suspensions.length > 0">
  <h4 class="guest-invite-extras-title">Suspensões de regras por dia</h4>
  <p-table
    [value]="suspensions"
    styleClass="easy-table guest-invite-extras-table"
    [tableStyle]="{ 'min-width': '700px' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">Data</th>
        <th class="text-center">Motivo</th>
        <th class="text-center">Autorizado em</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ação</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [class.guest-invite-extras-row--canceled]="row.canceledAt">
        <td class="no-wrap text-center">{{ row.suspensionDate | date : "dd/MM/yyyy" }}</td>
        <td class="text-center">{{ row.note || "—" }}</td>
        <td class="no-wrap text-center">{{ row.authorizedAt | date : "dd/MM/yyyy HH:mm" }}</td>
        <td class="text-center">
          <span *ngIf="row.canceledAt" class="status-pill status-pill--blocked">Cancelada</span>
          <span *ngIf="!row.canceledAt" class="status-pill status-pill--allowed">Ativa</span>
        </td>
        <td class="text-center">
          <button
            *ngIf="!row.canceledAt"
            type="button"
            class="easymarine danger"
            (click)="cancelSuspension(row)"
            pTooltip="Cancelar esta suspensão"
            tooltipPosition="left"
          >
            <i class="pi pi-times"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="guest-invite-table-wrap" *ngIf="inviteRows.length > 0">
  <p-table
    [value]="displayedRows"
    styleClass="easy-table guest-invite-table"
    [scrollable]="true"
    scrollHeight="480px"
    [tableStyle]="{ 'min-width': '1200px' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">Emissão</th>
        <th class="text-center">Origem</th>
        <th class="text-center">Convite ativo</th>
        <th class="text-center">Solicitante</th>
        <th class="text-center">Convidado</th>
        <th class="text-center">Nº pedido</th>
        <th class="text-center">Início permissão</th>
        <th class="text-center">Fim permissão</th>
        <th class="text-center">Status liberação</th>
        <th class="text-center">Cancelado em</th>
        <th class="text-center">Veículo</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="no-wrap text-center">
          {{ row.emissionDate | date : "dd/MM/yyyy HH:mm" }}
        </td>
        <td class="text-center">
          <span [class]="getOriginClass(row)">{{ getOriginLabel(row) }}</span>
        </td>
        <td class="text-center">{{ row.inviteActive ? "Sim" : "Não" }}</td>
        <td class="text-center">{{ row.customerResponsibleName || "—" }}</td>
        <td class="text-center">{{ row.emissionTo || "—" }}</td>
        <td class="text-center">{{ row.orderNumber || row.orderId || "—" }}</td>
        <td class="no-wrap text-center">
          {{ row.starDate | date : "dd/MM/yyyy" }}
        </td>
        <td class="no-wrap text-center">
          {{ row.endDate | date : "dd/MM/yyyy" }}
        </td>
        <td class="text-center">
          <span [class]="getLiberationStatusClass(row.liberationStatus)">
            {{ getLiberationStatusLabel(row.liberationStatus) }}
          </span>
        </td>
        <td class="no-wrap text-center">
          {{
            row.canceledDate
              ? (row.canceledDate | date : "dd/MM/yyyy HH:mm")
              : "—"
          }}
        </td>
        <td class="no-wrap guest-invite-vehicle text-center">
          <span *ngIf="row.carPlate ">
            {{ row.carPlate }}
          </span>
          <span *ngIf="!row.carPlate && !row.carModel && !row.carColor">—</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12" class="guest-invite-empty">
          Nenhum registro neste mês. Ajuste o filtro de mês ou busque outro período.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p class="guest-invite-hint" *ngIf="inviteRows.length === 0">
  Use o número do título e o ano para buscar os usos de convite.
</p>
